export default __webpack_public_path__ + "static/img-services-b88e0b85bb2cbc931ffcd2f7ff66ecb8.jpg";